import React from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "@/lib/utils";

interface ConditionalRouteProps {
  component: React.ComponentType;
  /**
   * 'private': Requires authentication (redirects to /login if not authenticated).
   * 'public': Visible to everyone (no redirection).
   * 'guest-only': Only for non-authenticated users (redirects to /dashboard if authenticated).
   */
  routeMode?: "private" | "public" | "guest-only";
}

const ConditionalRoute: React.FC<ConditionalRouteProps> = ({
  component: Component,
  routeMode = "public",
}) => {
  const isAuthenticated = !!getToken();

  if (routeMode === "private" && !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (routeMode === "guest-only" && isAuthenticated) {
    console.log("User is already authenticated. Redirecting to dashboard from guest-only route.");
    return <Navigate to="/dashboard" replace />;
  }


  return <Component />;
};

export default ConditionalRoute;

